import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from '../../_services/storage/storage.service';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';

@Injectable()
export class LanguageHeaderInterceptor implements HttpInterceptor {
  constructor(
    private storage: StorageService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject('LOCALE_FROM_URL') private localeFromUrl?: string
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Only add language headers to BidxSell API requests, not external APIs (e.g., WordPress)
    const isBidxSellApi = req.url.startsWith(environment.url);
    if (!isBidxSellApi) {
      return next.handle(req);
    }

    let languageCode = '';
    let languageName = '';
    let languageId = '';

    if (isPlatformBrowser(this.platformId)) {
      const lang = JSON.parse(
        localStorage.getItem(this.storage.getPrefixedKey('selectedLang')) ?? '{}'
      );

      if (lang?.short_name) {
        languageCode = lang.short_name;
        languageName = lang.name || '';
        languageId = lang.id?.toString() || '';
      }
    }

    if (!languageCode && this.localeFromUrl) {
      languageCode = this.localeFromUrl;
      languageName = this.localeFromUrl === 'ar' ? 'Arabic' : 'English';
    }

    if (!languageCode) {
      return next.handle(req);
    }

    const clonedReq = req.clone({
      setHeaders: {
        'X-Language': languageCode,
        'App-Content-Language-Name': languageName,
        'App-Content-Language-ID': languageId,
      },
    });

    return next.handle(clonedReq);
  }
}
